const EXERCISES_UI_ACTION = {
  UPDATE_QUERY: 'EXERCISES_UI_UPDATE_QUERY',
  UPDATE_PAGE: 'EXERCISES_UI_UPDATE_PAGE',
  UPDATE_EQUIPMENT_FILTER: 'EXERCISES_UI_UPDATE_EQUIPMENT_FILTER',
  UPDATE_FILTERS_FROM_WORKOUT_EXERCISE: 'EXERCISES_UI_UPDATE_FILTERS_FROM_WORKOUT_EXERCISE',
  DELETE_EQUIPMENT_FILTER: 'EXERCISES_UI_DELETE_EQUIPMENT_FILTER',
  UPDATE_MUSCLE_FILTER: 'EXERCISES_UI_UPDATE_MUSCLE_FILTER',
  DELETE_FILTERS: 'EXERCISES_UI_DELETE_FILTERS',
  DELETE_MUSCLE_FILTER: 'EXERCISES_UI_DELETE_MUSCLE_FILTER',
  UPDATE_TYPE_FILTER: 'EXERCISES_UI_UPDATE_TYPE_FILTER',
  DELETE_TYPE_FILTER: 'EXERCISES_UI_DELETE_TYPE_FILTER',
  DELETE_MUSCLE_GROUP_FILTER: 'EXERCISES_UI_DELETE_MUSCLE_GROUP_FILTER',
  UPDATE_MUSCLE_GROUP_FILTER: 'EXERCISES_UI_UPDATE_MUSCLE_GROUP_FILTER',
  UPDATE_EQUIPMENT_LIST_FILTER: 'EXERCISES_UI_UPDATE_EQUIPMENT_LIST_FILTER',
  UPDATE_EQUIPMENT_LIST_QUICK_FILTER: 'EXERCISES_UI_UPDATE_EQUIPMENT_LIST_QUICK_FILTER'
}

export default EXERCISES_UI_ACTION
